module.exports = __webpack_public_path__ + "assets/8a79714c1d63d951e36174f11f18e065.png";